import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { speed } from 'src/ui/common/config/animations';
import { Visible } from 'src/ui/common/layouts/visible';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

interface IStyledWrapper {
    disabled?: boolean;
}

export const StyledFilters = styled.div<{ visible: boolean }>`
    position: relative;
    width: ${({ visible }) => (visible ? '276px' : '0')};
    padding-left: 20px;
    height: 100%;
    transition: width ${speed.content} ease-in-out;
    white-space: nowrap;

    ${media.md`
    width: ${({ visible }: any) => (visible ? '339px' : '0')};
  `}

    & > div {
        height: 100%;
        transition: margin-left ${speed.content} ease-in-out;
        margin-left: ${({ visible }) => (visible ? '0' : '-200%')};
        overflow: hidden;
    }

    & svg {
        margin-right: 10px;
    }
`;

export const StyledVisible = styled(Visible)`
    height: 100%;
`;

export const StyledWrapper = styled(FlexBox)<IStyledWrapper>`
    height: 100%;
    cursor: pointer;
    color: ${({ theme, disabled }) => (disabled ? theme.colors.gs400 : theme.colors.pink500)};
    user-select: none;
    overflow: hidden;

    & svg,
    & svg:hover {
        color: ${({ disabled, theme }) => (disabled ? theme.colors.gs400 : theme.colors.pink500)};
    }

    ${({ disabled, theme }) => disabled && `pointer-events: none; color: ${theme.colors.gs400}`}
`;

export const StyledIcon = styled(FlexBox)<{ visible: boolean }>`
    position: relative;

    & svg {
        opacity: ${({ visible }) => (visible ? '1' : '0')};
    }
`;

export const StyledClearBtn = styled(Typography)`
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: auto;
    color: ${({ theme }) => theme.colors.gs200};
    border-right: 1px solid ${({ theme }) => theme.colors.gs100};
    border-left: 1px solid ${({ theme }) => theme.colors.gs100};
    padding: 0 20px;
`;
